$(document).ready(function(){
    const plici_texteSimple = 'Livraison le ';
    const plici_texteMultiple = 'Livraison entre le ';
    const plici_texteEt = ' et le ';

    if ($('.cart-help .card-body.deliveryinfo').length >= 1) {
        $.each($('input[name^=delivery_option]:checked'), function()
        {
            var date_from = null;
            var date_to = null;
            var date = cartDatesDelivery[$(this).attr('name').replace(/delivery_option\[(.*)\]/, '$1')][$(this).val()];

            if (typeof(date) != 'undefined')
            {
                if (date_from == null || date_from[1] < date['minimal'][1])
                    date_from = date['minimal'];
                if (date_to == null || date_to[1] < date['maximal'][1])
                    date_to = date['maximal'];
            }
            if(date_from[0] == date_to[0])
            {
                $('.cart-help .card-body.deliveryinfo .deliveryinfo__carrier_delay').html(plici_texteSimple +date_to[0]);
            }
            else
            {
                $('.cart-help .card-body.deliveryinfo .deliveryinfo__carrier_delay').html(plici_texteMultiple + date_from[0] + plici_texteEt +date_to[0]);
            }
            $('.cart-help .card-body.deliveryinfo .deliveryinfo__carrier_delay').css('display','block');
        });
    }
    $.each($('input[name^=delivery_option]'), function()
    {
        var date_from = null;
        var date_to = null;
        var date = cartDatesDelivery[$(this).attr('name').replace(/delivery_option\[(.*)\]/, '$1')][$(this).val()];

        if (typeof(date) != 'undefined')
        {
            if (date_from == null || date_from[1] < date['minimal'][1])
                date_from = date['minimal'];
            if (date_to == null || date_to[1] < date['maximal'][1])
                date_to = date['maximal'];
        }
        if(date_from[0] == date_to[0])
        {
            $(this).siblings('label').find('.checkout-option__resume__delay').html(plici_texteSimple +date_to[0]);
        }
        else
        {
            $(this).siblings('label').find('.checkout-option__resume__delay').html(plici_texteMultiple + date_from[0] + plici_texteEt +date_to[0]);
        }
        $(this).siblings('label').find('.checkout-option__resume__delay').css('display','block');
    });
});